<template>
  <div class="left-nav-upper" :class="{'justify-center': isEnableAddinPowerpoint }">
    <div v-if="!canEditPresentation" class="overlay-disable-top-side-left"></div>
    <div class="left-nav-upper__button" @click="addNewSlide()">
      <aha-icon
        name="add"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        class="text-secondary-100"
      />
      <p class="left-nav-upper__button-label">
        Slide
      </p>
    </div>
    <div class="left-nav-upper__button mx-1" @click="onAIButtonClicked()">
      <aha-icon
        name="sparkles"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        class="text-secondary-100"
      />
      <p class="left-nav-upper__button-label mr-0.5">
        {{ $i18nPresenter.t('AI') }}
      </p>
    </div>
    <div
      v-if="!isEnableAddinPowerpoint"
      class="left-nav-upper__button"
      @click="importPpt()"
      :class="{'disabled': isImportButtonDisabled}"
    >
      <aha-icon
        name="import"
        width="20"
        height="21"
        viewBox="0 0 24 25"
        class="text-secondary-100"
        v-if="!isImportingSlides"
      />
      <aha-spinner v-if="isImportingSlides" />
      <p class="left-nav-upper__button-label">
        Import
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import utils from '@/util'
import configs from '@/config'
import EventBus from '@/eventBus'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'

export default {
  props: {
    isSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('rightNav', ['rightNavTabNames', 'rightNavActiveTab']),
    ...mapGetters('rightPanelContainer', ['rightPanelContainerActiveTabs']),
    ...mapGetters('featureToggles', ['canUseAIImprovingSlideContent']),

    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      canEditPresentation: (state) => state.canEditPresentation,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
    }),

    isImportButtonDisabled() {
      return this.isSelectMode
    },
  },

  mounted() {
    EventBus.$on('openImport', () => {
      this.importPpt()
    })
  },

  destroyed() {
    EventBus.$off('openImport')
  },

  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    ...mapActions('rightPanelContainer', ['setRightPanelContainerActiveTabAction']),

    addNewSlide() {
      this.$emit('addNewSlide')
    },

    _getButtonLabel() {
      return this.rightNavTabNames.AI
    },

    onAIButtonClicked() {
      const buttonLabel = this._getButtonLabel()
      this.setRightNavActiveTabAction(buttonLabel)

      utils.trackGA4AndMixpanel('Open AI Panel', {
        eventAction: 'Open AI Panel',
        eventCategory: EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
        slideId: this.slideActive && this.slideActive.id,
        presentationId: this.presentation.id,
        userId: this.currentUser.id,
        touch_point: 'Left nav upper',
      })
    },

    _isReachLimitSlides() {
      if (this.presentation.slides.length >= configs.MAX_NUMBER_OF_SLIDE) {
        EventBus.$emit('openModalLimitSlides')
        this.$store.state.openImportModal = false
        return true
      }
      return false
    },

    importPpt() {
      this.$store.state.openImportModal = true
      if (this._isReachLimitSlides()) return
      utils.mixpanelTracking(
        EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
        'Import > Open modal',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.left-nav-upper {
  @apply relative flex w-full;
  @apply items-center justify-center;
}
.left-nav-upper__button {
  @apply hover:bg-secondary-15 cursor-pointer;
  @apply flex flex-col items-center justify-center p-2 my-1;
  width: 56px;
  border-radius: 4px;
  transition: all 0.1s ease-in-out;
  .left-nav-upper__button-label {
    @apply text-xs pt-1;
  }
}
.overlay-disable-top-side-left {
  @apply bg-base-0 opacity-50 absolute top-0 left-0 w-full h-full;
  z-index: 9;
}
</style>
